import React from "react";
import { DebounceInput } from "react-debounce-input";
import { useDataLoader } from "react-remote-data-hooks";
import {
  Customer,
  LeadCustomerDetails,
  useConfiguration,
  useOutsideClick,
} from "..";
import api from "../../api";
import moment from "moment";
import classnames from "classnames";
import { CustomerAvatar } from "../../components/render-file/CustomerAvatar";
import { useHistory } from "react-router";
import { RouteKeys } from "../../containers/routes/route-keys";
import { GlobalSearchList, SearchHistory } from "../api/models/global-search";
import noImage from "../../assets/images/no-search-result.png";

const GlobalSearch: React.FunctionComponent<{ className?: string }> = (
  props
) => {
  const { openModal } = useConfiguration(api);

  const history = useHistory();
  const [search, setSearch] = React.useState("");
  const [category, setSategory] = React.useState("");
  const [showDropDown, setShowDropDown] = React.useState(false);

  const [showHistory, setShowHistory] = React.useState(false);
  const [showSearch, setShowSearch] = React.useState(false);

  const [alreadyLoaded, setAlreadyLoaded] = React.useState(false);

  const ref = React.useRef<HTMLDivElement>(null);

  useOutsideClick(ref, () => {
    setShowDropDown(false);
    setShowHistory(false);
  });

  const { data: shistory, reload: reloadHistory } = useDataLoader<{
    searchHistory: SearchHistory[];
    searchList: GlobalSearchList[];
  }>(() => api.globalSearch.getSearchHistory());

  const { data, loading, loaded, reload } = useDataLoader<GlobalSearchList[]>(
    async (query?: string, iCategory?: string) =>
      query
        ? api.globalSearch.getGlobalSearch(
            query,
            iCategory === "All Categories" ? "" : iCategory
          )
        : [],
    [search, category]
  );

  React.useEffect(() => {
    if (!alreadyLoaded && !!data?.length) {
      setAlreadyLoaded(true);
    }
  }, [data]);

  React.useEffect(() => {
    if (loaded) {
      reload(search, category);
      setShowDropDown(true);
      if (search) {
        setShowHistory(false);
      }
    }
  }, [search]);

  const getCustomerDisplayName = (customer: LeadCustomerDetails) => {
    return (
      customer.fullName ||
      `${customer?.firstName || ""} ${customer?.lastName || ""}`
    );
  };

  const onClick = () => {
    history.push(RouteKeys.GlobalSearch);
  };

  const onSelect = async (globalId: string, item: GlobalSearchList) => {
    if (item.searchType === "Quotation") {
      const lead = await api.lead.getLead(item?.configuration?.leadId);
      history.push(
        `${RouteKeys.Requirement.replace(":id", item?.configuration?._id!)}`
      );
    }
    if (item.searchType === "Customer") {
      history.push(`${RouteKeys.Lead360View}/${item?.customer?._id || ""}`);
    }
    if (item.searchType === "Lead") {
      history.push(`${RouteKeys.Leads}/${item?.lead?._id || ""}`);
    }
    if (item.searchType === "Vehicle") {
      history.push(`${RouteKeys.Vehicles}/${item?.vehicle?._id || ""}`);
    }
    if (globalId) {
      try {
        await api.globalSearch.updateSearchHistory(
          globalId,
          search,
          category || "All Categories"
        );
        reloadHistory();
      } catch (error) {
        // console
      }
    }
  };

  return (
    <div
      ref={ref}
      className={`headerSearch position-relative ${props.className || ""} ${
        showSearch === true ? "active" : ""
      }`}
    >
      <div className="headerSearch__field w-100 rounded-pill d-flex">
        <button
          type="submit"
          className="border-0 bg-transparent font-lg text-gray-500 px-3"
          onClick={() => onClick()}
        >
          <i className="icon-search"></i>
        </button>
        <DebounceInput
          className="headerSearch__input form-control bg-transparent border-0 h-auto p-0 font-normal"
          // minLength={3}
          debounceTimeout={300}
          onChange={(e) => {
            setShowHistory(false);
            setSearch(e.target.value);
          }}
          onFocus={() => {
            // if (search.length >= 3) {
            //   setShowDropDown(true);
            // }
            // if (search.length === 0) {
            //   setShowHistory(true);
            // }
            onClick();
          }}
          placeholder="Search"
          value={search}
        />
        {/* <input
          type="text"
          className="headerSearch__input form-control bg-transparent border-0 h-auto p-0 font-normal"
          placeholder="Search"
        /> */}
        <button
          type="submit"
          className="border-0 bg-transparent font-lg text-gray-500 px-3 headerSearch__close"
          onClick={() => {
            setShowSearch(false);
            setShowDropDown(false);
            setShowHistory(false);
          }}
        >
          <i className="icon-close"></i>
        </button>
      </div>

      {showHistory &&
        (!!shistory?.searchList?.length ||
          !!shistory?.searchHistory?.length) && (
          <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100 position-absolute left-0 bg-white zIndex-99 mt-1 pt-0 pb-3 rounded global-search-dropdown--sm">
            <div
              className={classnames({
                " overlay-loader": true,
                "d-block": loading,
                "d-none": !loading,
              })}
            ></div>
            {!!shistory?.searchHistory?.length && (
              <>
                <div className="text-gray-500 font-sm font-weight-semibold mb-2 mt-4">
                  Recent Keywords
                </div>
                {shistory?.searchHistory?.map((item) => {
                  return (
                    <div
                      onClick={() => {
                        // setShowHistory(false);
                        setSategory(item.category || "");
                        setSearch(item.keyWord);
                      }}
                      className="custom-dropdown__menu-item d-flex align-items-center cursor-pointer p-2 rounded"
                    >
                      <div className="avatar-progress avatar-progress--shamrock cursor-pointer">
                        <i
                          className="icon-search mr-2"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="">
                        <div className="font-sm font-weight-semibold">
                          {item.keyWord}
                        </div>
                        <div className="font-sm text-gray-500">
                          {item.category || "All Categories"}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
            {!!shistory.searchList?.length && (
              <>
                <div className="text-gray-500 font-sm font-weight-semibold mb-2 mt-4">
                  Recenty Viewed
                </div>
                {shistory.searchList?.map((item) => {
                  return (
                    <div
                      onClick={() => onSelect(item._id!, item)}
                      className="custom-dropdown__menu-item d-flex align-items-start cursor-pointer p-2 rounded"
                    >
                      <>
                        {item.searchType === "Vehicle" && (
                          <>
                            <div className="avatar-progress avatar-progress--shamrock cursor-pointer">
                              <i
                                className="icon-vehicle"
                                style={{ fontSize: "23px" }}
                              ></i>
                            </div>
                            <div className="px-2">
                              <div className="font-sm font-weight-semibold">
                                {item?.vehicle?.variant?.name}
                              </div>
                              <div className="font-sm text-gray-500">
                                Vin Number : {item?.vehicle?.vinNumber}
                              </div>
                              <div className="font-sm text-gray-500">
                                VSB Number : {item?.vehicle?.vsbNumber}
                              </div>
                              <div className="font-sm text-gray-500">
                                XCO : {item?.vehicle?.xco}
                              </div>
                              <div className="font-sm font-weight-light"></div>
                            </div>
                          </>
                        )}
                        {item.searchType === "Lead" && (
                          <>
                            <div className="avatar-progress avatar-progress--shamrock cursor-pointer">
                              <i
                                className="icon-lead"
                                style={{ fontSize: "23px" }}
                              ></i>
                            </div>
                            <div className="px-2">
                              <div className="font-sm font-weight-semibold">
                                {item?.lead?.title}
                              </div>
                              {item?.salesPerson?.name && (
                                <div className="font-sm text-gray-500">
                                  <span className="text-gray-500">
                                    {item?.salesPerson?.name}
                                  </span>
                                </div>
                              )}
                              {item?.lead?.enquiryNumber && (
                                <div className="font-sm text-gray-500">
                                  <span className="text-gray-500">
                                    {item?.lead?.enquiryNumber}
                                  </span>
                                </div>
                              )}
                              <div className="font-sm font-weight-light"></div>
                            </div>
                          </>
                        )}
                        {item.searchType === "Quotation" && (
                          <>
                            <div className="avatar-progress avatar-progress--shamrock cursor-pointer">
                              <i
                                className="icon-quotation"
                                style={{ fontSize: "23px" }}
                              ></i>
                            </div>
                            <div className="px-2">
                              <div className="font-sm font-weight-semibold">
                                {item?.configuration?.vehicle?.variant?.name}
                                {item?.configuration?.quotationNumber && (
                                  <> - {item?.configuration?.quotationNumber}</>
                                )}
                              </div>
                              {item?.configuration?.customer?.fullName && (
                                <div className="font-sm text-gray-500">
                                  <span className="text-gray-500">
                                    {item?.configuration?.customer?.fullName}
                                  </span>
                                </div>
                              )}
                              {item.configuration?.quotationCreatedAt && (
                                <div className="font-sm text-gray-500">
                                  <span className="text-gray-500">
                                    {moment(
                                      item.configuration?.quotationCreatedAt
                                    ).format("ddd MMM DD, YYYY")}
                                  </span>{" "}
                                </div>
                              )}

                              <div className="font-sm font-weight-light"></div>
                            </div>
                          </>
                        )}
                        {item.searchType === "Customer" && (
                          <>
                            <div className="avatar-progress avatar-progress--shamrock cursor-pointer avatar-progress--smx">
                              <CustomerAvatar
                                id={item?.customer?._id}
                                className="m-auto rounded-circle"
                                alt={item?.customer?.fullName}
                                title={item?.customer?.fullName}
                                imageUrl={
                                  item?.customer?.photo?.location ||
                                  item?.customer?.avatar?.location
                                }
                                image={
                                  item?.customer?.photo ||
                                  item?.customer?.avatar
                                }
                              ></CustomerAvatar>
                            </div>
                            <div className="px-2">
                              <div className="font-sm font-weight-semibold">
                                {getCustomerDisplayName(item?.customer!)}
                              </div>
                              <div className="font-sm text-gray-500">
                                {item?.customer?.email}
                              </div>
                              <div className="font-sm text-gray-500">
                                {item?.customer?.phone}
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        )}

      {showDropDown && search && (
        <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100 position-absolute left-0 bg-white zIndex-99 mt-1 pt-0 pb-0 rounded">
          <div
            className={classnames({
              " overlay-loader": true,
              "d-block": loading,
              "d-none": !loading,
            })}
          ></div>
          {!!shistory?.searchHistory?.length && (
            <>
              <div className="text-gray-500 font-sm font-weight-semibold mb-2 mt-4">
                Recent Keywords
              </div>
              {shistory?.searchHistory?.map((item) => {
                return (
                  <div
                    onClick={() => {
                      // setShowHistory(false);
                      setSategory(item.category || "");
                      setSearch(item.keyWord);
                    }}
                    className="custom-dropdown__menu-item d-flex align-items-center cursor-pointer p-2 rounded"
                  >
                    <div className="avatar-progress avatar-progress--shamrock cursor-pointer">
                      <i
                        className="icon-search mr-2"
                        style={{ fontSize: "20px" }}
                      ></i>
                    </div>
                    <div className="">
                      <div className="font-sm font-weight-semibold">
                        {item.keyWord}
                      </div>
                      <div className="font-xs text-gray-500">
                        {item.category || "All Categories"}
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
          <div className="row gutter-10">
            <div className="col-md col-12 pb-3">
              {loaded && (
                <div className="text-gray-500 font-sm font-weight-semibold mb-2 mt-4 pl-3">
                  All search results
                </div>
              )}

              {!!data?.length && (
                <>
                  {data?.map((item) => {
                    return (
                      <div
                        onClick={() => onSelect(item._id!, item)}
                        className="custom-dropdown__menu-item d-flex align-items-start cursor-pointer rounded p-2"
                      >
                        <>
                          {item.searchType === "Vehicle" && (
                            <>
                              <div className="avatar-progress avatar-progress--shamrock cursor-pointer">
                                <i className="icon-vehicle font-lg mr-2"></i>
                              </div>
                              <div className="px-2">
                                <div className="font-sm font-weight-semibold">
                                  {item?.vehicle?.variant?.name}
                                </div>
                                <div className="font-sm">
                                  Vin Number : {item?.vehicle?.vinNumber}
                                </div>
                                <div className="font-sm text-gray-500">
                                  VSB Number : {item?.vehicle?.vsbNumber}
                                </div>
                                <div className="font-sm text-gray-500">
                                  XCO : {item?.vehicle?.xco}
                                </div>
                                <div className="font-sm text-gray-500"></div>
                              </div>
                            </>
                          )}
                          {item.searchType === "Lead" && (
                            <>
                              <div className="avatar-progress avatar-progress--shamrock cursor-pointer">
                                <i className="icon-lead font-lg mr-2"></i>
                              </div>
                              <div className="px-2">
                                <div className="font-sm font-weight-semibold">
                                  {item?.lead?.title}
                                </div>
                                {item?.salesPerson?.name && (
                                  <div className="font-sm text-gray-500">
                                    <span className="text-gray-500">
                                      {item?.salesPerson?.name}
                                    </span>
                                  </div>
                                )}
                                {item?.lead?.enquiryNumber && (
                                  <div className="font-sm text-gray-500">
                                    <span className="text-gray-500">
                                      {item?.lead?.enquiryNumber}
                                    </span>
                                  </div>
                                )}
                                <div className="font-sm font-weight-light"></div>
                              </div>
                            </>
                          )}
                          {item.searchType === "Quotation" && (
                            <>
                              <div className="avatar-progress avatar-progress--shamrock cursor-pointer">
                                <i className="icon-quotation font-lg mr-2"></i>
                              </div>
                              <div className="px-2">
                                <div className="font-sm font-weight-semibold">
                                  {item?.configuration?.vehicle?.variant?.name}
                                  {item?.configuration?.quotationNumber && (
                                    <>
                                      {" "}
                                      - {item?.configuration?.quotationNumber}
                                    </>
                                  )}
                                </div>
                                {item?.configuration?.customer?.fullName && (
                                  <div className="font-sm text-gray-500">
                                    <span className="text-gray-500">
                                      {item?.configuration?.customer?.fullName}
                                    </span>
                                  </div>
                                )}
                                {item.configuration?.quotationCreatedAt && (
                                  <div className="font-sm text-gray-500">
                                    <span className="text-gray-500">
                                      {moment(
                                        item.configuration?.quotationCreatedAt
                                      ).format("ddd MMM DD, YYYY")}
                                    </span>{" "}
                                  </div>
                                )}
                                <div className="font-sm font-weight-light"></div>
                              </div>
                            </>
                          )}
                          {item.searchType === "Customer" && (
                            <>
                              <div className="avatar-progress avatar-progress--shamrock cursor-pointer avatar-progress--smx">
                                <CustomerAvatar
                                  id={item?.customer?._id}
                                  className="m-auto rounded-circle font-lg mr-2"
                                  alt={item?.customer?.fullName}
                                  title={item?.customer?.fullName}
                                  imageUrl={
                                    item?.customer?.photo?.location ||
                                    item?.customer?.avatar?.location
                                  }
                                  image={
                                    item?.customer?.photo ||
                                    item?.customer?.avatar
                                  }
                                ></CustomerAvatar>
                              </div>
                              <div className="px-2">
                                <div className="font-sm font-weight-semibold">
                                  {getCustomerDisplayName(item?.customer!)}
                                </div>
                                <div className="font-sm text-gray-500">
                                  {item?.customer?.email}
                                </div>
                                <div className="font-sm text-gray-500">
                                  {item?.customer?.phone}
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      </div>
                    );
                  })}
                </>
              )}
              {!data?.length && loaded && (
                <div
                  onClick={() => {
                    setShowDropDown(false);
                    setAlreadyLoaded(false);
                    setSearch("");
                    setShowHistory(true);
                    setSategory("");
                  }}
                  className="my-3 py-5 d-flex align-items-center justify-content-center font-sm text-gray-500 font-weight-normal flex-column text-center col-12"
                >
                  <img
                    src={noImage}
                    className="img-fluid mb-3 cursor-pointer"
                    alt="no result found"
                  />
                  Your recent search history & recently
                  <br /> viewed items will shown here
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GlobalSearch;
